import { concat } from '@ember/helper';
import { LinkTo } from '@ember/routing';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import { dasherize, pluralize } from '@warp-drive/utilities/string';
import { t } from 'ember-intl';
import momentFormat from 'ember-moment/helpers/moment-format';
import { trackedFunction } from 'reactiveweb/function';

import { findRecord } from 'umg-ember-backend/data/builders/umg-rest';
import type FlashMessagesService from 'umg-ember-backend/services/flash-messages';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from './styles.module.css';

const bem = getBem(styles);

interface Activity {
  type: string;
  id: string;
  editedAt: string;
}

interface DashboardActivityFeedItemSignature {
  Args: {
    activity: Activity;
  };
  Element: HTMLDivElement;
}

export default class DashboardActivityFeedItemComponent extends Component<DashboardActivityFeedItemSignature> {
  @service declare store: TODO;
  @service declare flashMessages: FlashMessagesService;

  get record() {
    return this.loadRecord.value;
  }

  get recordType() {
    return dasherize(this.args.activity.type);
  }

  get route() {
    return `admin.${pluralize(this.recordType)}.${this.recordType}`;
  }

  loadRecord = trackedFunction(this, async () => {
    try {
      const { content } = await this.store.request(
        findRecord(this.recordType, this.args.activity.id),
      );

      return content.data;
    } catch (error) {
      this.flashMessages.serverError(error);
    }
  });

  <template>
    <div class={{(bem)}} ...attributes>
      <div class={{bem 'meta'}}>
        <span class={{bem 'model'}} data-test-activity-model-name>
          {{t (concat 'models.' this.recordType)}}
        </span>
        <time class={{bem 'time'}} datetime={{@activity.editedAt}}>
          {{momentFormat @activity.editedAt 'L LT'}}
        </time>
      </div>
      <div class={{bem 'record'}}>
        {{#if this.record}}
          <LinkTo
            @route={{this.route}}
            @model={{this.record.id}}
            class={{bem 'link'}}
            data-test-activity-link
          >
            {{this.record.displayLabel}}
          </LinkTo>
        {{else}}
          <span>{{t 'ui.loading'}}</span>
        {{/if}}
      </div>
    </div>
  </template>
}
